import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import muiTheme from './style/colors'
import injectTapEventPlugin from 'react-tap-event-plugin'
import './style/index.css'
import './style/flexboxgrid.css'

// Load temporary workaround for tap events
injectTapEventPlugin()

// Remove the loading splash page and create a root element
if (document.body.className.indexOf('loading') !== -1) {
  document.body.classList.remove('loading')
  document.body.innerHTML = `<div id='root'></div>`
}

// Register the service worker
if (process.env.NODE_ENV === 'production') {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/service-worker.js')
  }
}

// Render the app with a customized theme
ReactDOM.render(
  <MuiThemeProvider muiTheme={muiTheme}>
    <App />
  </MuiThemeProvider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js